import script from "./marketing-kyt-approval.vue?vue&type=script&setup=true&lang=js"
export * from "./marketing-kyt-approval.vue?vue&type=script&setup=true&lang=js"

import "./marketing-kyt-approval.vue?vue&type=style&index=0&id=c13bae96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c13bae96"]])

export default __exports__